export enum WidgetType {
    UNIFIED_RECEIVE = "Unified Receive",
    INVENTORY_ADJUSTMENT = "Inventory Adjustment"
}